<script>
    import { cms_host, api_host, user_store, toast_options, domain_code_store, subdomain_manager, bpm_domain, subscription_info_store, pricings_store } from './stores.js';
    import { init_data } from './init.js';
    import Router, { push, querystring } from 'svelte-spa-router';
    import Login from './components/auth/login.svelte';
    import Register from './components/auth/register.svelte';
    import Activate from './components/auth/activate.svelte';
    import ResetPassword from './components/auth/resetpassword.svelte';
    import RedirectToken from './components/auth/redirecttoken.svelte';
    import SetupAuth from './components/auth/setupauth.svelte';
    import Loading from './components/loading.svelte';
    import App from './App.svelte';
    import { getToken, doFetch } from './utils/Fetching.js';
    import { onMount } from 'svelte';
    import { SvelteToast } from '@zerodevx/svelte-toast';


    let is_loaded = null;
    const { auth_type, auth_token, domain_code } = getToken();
    onMount(async () => {
        console.log('domain_code', domain_code);
        const res = await doFetch(
            api_host + `/auth/user`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );
        const { email, is_trial, first_name, last_name, id, username, role, is_subscribed, plan_type, plan_freq, paid_at, subscription } = res;
        if (res['id']) {
            user_store.update(prev => {
                is_loaded = true;
                prev['is_trial'] = is_trial;
                prev['is_authenticated'] = true;
                prev['is_subscribed'] = is_subscribed;
                prev['email'] = email;
                prev['first_name'] = first_name;
                prev['last_name'] = last_name;
                prev['id'] = id;
                prev['username'] = username;
                prev['role'] = role;
                prev['plan_freq'] = plan_freq
                prev['plan_type'] = plan_type;
                prev['paid_at'] = paid_at;
                prev['subscription'] = subscription;
                return prev;
            });
            if (!is_subscribed) {
                if (!window.location.href.includes('Choose_Plan')) {
                    push('#/Settingscompany?reg=first');
                }
            }
            const res = await doFetch(
                api_host + `/api/domain/get/mine`,
                'GET',
                {},
                { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
            );
            const { domain_name } = res;
            const subdomain = domain_name ? domain_name.replace(`.${bpm_domain}`, '') : '';
            subdomain_manager.set(subdomain);
            
            if (!(location.hash.length < 3 || location.hash.toLowerCase().includes('dashboard'))) {
                init_data('all');
            }
        } else {
            if (!(window.location.href.includes('register') || window.location.href.includes('activate') || window.location.href.includes('reset_password') || window.location.href.includes('set_token') || window.location.href.includes('setupauth') || window.location.href.includes('Register_Plan') || window.location.href.includes('Choose_Plan'))) {
                const params = new URLSearchParams($querystring);
                let _plan_type = '', _domain_name = '';
                if (params.has('domain_name') && params.has('plan_type')) {
                    _plan_type = params.get('plan_type');
                    _domain_name = params.get('domain_name');
                    console.log(_plan_type, _domain_name);
                    if (!window.location.href.includes('ContentHomepage')) {
                        push(`#/Register_Plan?plan_type=${_plan_type}&domain_name=${_domain_name}`);
                    }
                } else {
                    push('#/login');
                }
            }
            user_store.update(prev => {
                is_loaded = false;
                prev['is_authenticated'] = false;
                return prev;
            });
        }
        if (role === 'landscaper' || role === undefined) {
            const plan_res = await doFetch(
                cms_host + '/api/pricing?populate=pricing.plans.able_services.sub_service&populate=pricing.contact_form.background1',
                'GET',
                {},
                { 'Content-Type': 'application/json' }
            );
            if (plan_res['data'] && plan_res['data']['attributes']) {
                const plans = plan_res['data']['attributes']['pricing']['plans'];
                subscription_info_store.set({
                    'basic': [plans[0].price, plans[0].month_price],
                    'pro': [plans[1].price, plans[1].month_price],
                    'prime': [plans[2].price, plans[2].month_price],
                    'free': [0, 0],
                });
                pricings_store.set(plan_res['data']['attributes']['pricing']);
            }
        }
        const domain_obj = await doFetch(`${api_host}/api/domain/get/current`, 'GET');
        domain_code_store.set(domain_obj ? domain_obj.code : '');
    });
    const routes = {
        '/login': Login,
        '/register': Register,
        '/activate/:uid/:token/:userId': Activate,
        '/reset_password/:uid/:token/:userId/:userEmail': ResetPassword,
        '/set_token/:token': RedirectToken,
        '/setupauth': SetupAuth,
        '/*': App
    };
</script>

<SvelteToast options={$toast_options} />

{#if is_loaded == null}
    <Loading />
{:else}
    <Router routes={routes} />
{/if}